import React, { useState } from 'react';
import SEO from '../../components/ui/SEO';
import { ChevronDown, ChevronUp, FileText, Users, Clock, Lock, AlertCircle, DollarSign, Scale, HelpCircle } from 'lucide-react';
export default function Terms() {
  const [openSections, setOpenSections] = useState({
    definitions: true,
    instruction: true,
    duties: true,
    services: true,
    fees: true,
    timelines: true,
    dataProtection: true,
    intellectual: true,
    cancellation: true,
    liability: true,
    complaints: true,
    governing: true,
    amendments: true
  });
  const toggleSection = section => {
    setOpenSections(prev => ({
      ...prev,
      [section]: !prev[section]
    }));
  };
  return <main className="min-h-screen bg-white" data-id="element-854" data-mp="131xxul3r2wjq">
      <SEO title="Terms and Conditions | Expert Witness Instructions" description="Service agreement, professional obligations, data protection and fee terms for psychiatric expert witness instructions. Read before instructing." path="/policies/terms" keywords={['expert witness terms and conditions', 'psychiatric expert witness service agreement']} imageAlt="Terms and conditions for psychiatric expert witness instructions" data-id="element-855" data-mp="1352dcemo1epp" />
      {/* Hero Section */}
      <section className="bg-primary text-white py-10 pt-24 md:pt-28" data-id="element-856" data-mp="3qd5246s963u">
        <div className="container mx-auto px-4" data-id="element-857" data-mp="3l7mm7z24n5bx">
          <div className="flex items-center justify-center mb-4" data-id="element-858" data-mp="3l6upum0ph3kl">
            <Scale className="h-12 w-12 mr-4" data-id="element-859" data-mp="3pyw9it07dwkn" />
            <h1 className="text-3xl md:text-4xl lg:text-5xl font-serif font-bold" data-id="element-860" data-mp="3pznrv24shxsz">
              Terms & Conditions
            </h1>
          </div>
        </div>
      </section>
      {/* Terms Content */}
      <section className="py-12" data-id="element-861" data-mp="3g8t8c5ixhcb8">
        <div className="container mx-auto px-4" data-id="element-862" data-mp="3291xuermee1z">
          <div className="max-w-3xl mx-auto" data-id="element-863" data-mp="329a8s146n9aj">
            <p className="text-slate-dark text-lg mb-8" data-id="element-864" data-mp="377lkyihy9vvx">
              These Terms and Conditions govern the provision of medico-legal
              psychiatric services by Dr. Imtiaz Syed (operating as "Medicolegal
              Psychiatry") to the instructing party. By instructing Dr. Syed,
              you are agreeing to these terms.
            </p>
            <div className="space-y-4 mb-8" data-id="element-865" data-mp="13zkw37r5lznj">
              {/* Definitions Section */}
              <div className="border border-gray-200 rounded-lg overflow-hidden" data-id="element-866" data-mp="z1t4yfyc2hke">
                <button className={`w-full px-6 py-4 text-left flex justify-between items-center ${openSections.definitions ? 'bg-primary text-white' : 'bg-gray-50 text-primary'}`} onClick={() => toggleSection('definitions')} data-id="element-867" data-mp="1vphck40rqrpp">
                  <div className="flex items-center" data-id="element-868" data-mp="1hr97f8tkwk3g">
                    <FileText className="h-5 w-5 mr-2" data-id="element-869" data-mp="1hsu2czjt251u" />
                    <h2 className="text-xl font-serif font-bold" data-id="element-870" data-mp="bbp1q9p24jtx">
                      1. Definitions
                    </h2>
                  </div>
                  {openSections.definitions ? <ChevronUp className="h-5 w-5" data-id="element-871" data-mp="3se31cj7149qq" /> : <ChevronDown className="h-5 w-5" data-id="element-872" data-mp="167b7cyh4i8x" />}
                </button>
                {openSections.definitions && <div className="p-6 bg-white" data-id="element-873" data-mp="648qdmss3xf4">
                    <ul className="space-y-2 text-slate-dark" data-id="element-874" data-mp="awa4zfdf608b">
                      <li data-id="element-875" data-mp="aymuqepf5evx">
                        <strong data-id="element-876" data-mp="eydq6vpw4j6s">"Dr. Syed"</strong> refers to Dr. Imtiaz Syed,
                        operating as Medicolegal Psychiatry.
                      </li>
                      <li data-id="element-877" data-mp="jvdoulkeujnv">
                        <strong data-id="element-878" data-mp="owbbbacgdzv6">"Instructing Party"</strong> refers to the
                        solicitor, law firm, court, tribunal, or other entity
                        that instructs Dr. Syed.
                      </li>
                      <li data-id="element-879" data-mp="2qog4ep5ov37h">
                        <strong data-id="element-880" data-mp="2qp9270mo6idh">"Subject"</strong> refers to the individual who
                        is to be assessed by Dr. Syed.
                      </li>
                      <li data-id="element-881" data-mp="pxz0qurv1t3v">
                        <strong data-id="element-882" data-mp="px5r9m1iopi1">"Services"</strong> refers to the medico-legal
                        psychiatric assessments, report writing, and expert
                        witness testimony provided by Dr. Syed.
                      </li>
                    </ul>
                  </div>}
              </div>
              {/* Instruction Section */}
              <div className="border border-gray-200 rounded-lg overflow-hidden" data-id="element-883" data-mp="69zsbqkrqy1m">
                <button className={`w-full px-6 py-4 text-left flex justify-between items-center ${openSections.instruction ? 'bg-primary text-white' : 'bg-gray-50 text-primary'}`} onClick={() => toggleSection('instruction')} data-id="element-884" data-mp="28w8yu3iijvn">
                  <div className="flex items-center" data-id="element-885" data-mp="b7rhicu14624">
                    <FileText className="h-5 w-5 mr-2" data-id="element-886" data-mp="3jocl1e3w66xu" />
                    <h2 className="text-xl font-serif font-bold" data-id="element-887" data-mp="3eqazmmiztvj7">
                      2. Instruction and Acceptance
                    </h2>
                  </div>
                  {openSections.instruction ? <ChevronUp className="h-5 w-5" data-id="element-888" data-mp="1yzikjqutim6p" /> : <ChevronDown className="h-5 w-5" data-id="element-889" data-mp="1l7kh9wnsfkig" />}
                </button>
                {openSections.instruction && <div className="p-6 bg-white" data-id="element-890" data-mp="1q7qahh9phf2n">
                    <p className="text-slate-dark mb-4" data-id="element-891" data-mp="1q4azoqn2es71">
                      All instructions must be provided in writing, typically
                      via email to enquiries@medicolegal-psychiatry.co.uk. Dr.
                      Syed reserves the right to decline any instruction at his
                      discretion, particularly if there is a conflict of
                      interest or if the instruction falls outside his areas of
                      expertise.
                    </p>
                    <p className="text-slate-dark" data-id="element-892" data-mp="xhzypevjqp9p">
                      Upon acceptance of an instruction, Dr. Syed will provide a
                      Service Agreement outlining the specific services to be
                      provided, estimated timeframes, and fee structure. Work
                      will commence once this agreement has been signed and
                      returned by the Instructing Party.
                    </p>
                  </div>}
              </div>
              {/* Expert's Duties Section */}
              <div className="border border-gray-200 rounded-lg overflow-hidden" data-id="element-893" data-mp="3qvkvd7yhb72e">
                <button className={`w-full px-6 py-4 text-left flex justify-between items-center ${openSections.duties ? 'bg-primary text-white' : 'bg-gray-50 text-primary'}`} onClick={() => toggleSection('duties')} data-id="element-894" data-mp="3lunfj20xyp42">
                  <div className="flex items-center" data-id="element-895" data-mp="1g2gp1q907eia">
                    <Scale className="h-5 w-5 mr-2" data-id="element-896" data-mp="1g28dq2sj4h97" />
                    <h2 className="text-xl font-serif font-bold" data-id="element-897" data-mp="1b343r9xs6fht">
                      3. Expert's Duties
                    </h2>
                  </div>
                  {openSections.duties ? <ChevronUp className="h-5 w-5" data-id="element-898" data-mp="1nlpwhdxy934p" /> : <ChevronDown className="h-5 w-5" data-id="element-899" data-mp="1sczkyb7ri0f0" />}
                </button>
                {openSections.duties && <div className="p-6 bg-white" data-id="element-900" data-mp="1xb156zgxc5s2">
                    <p className="text-slate-dark" data-id="element-901" data-mp="1xdvnolgdngiu">
                      Dr. Syed acknowledges and accepts the overriding duty to
                      the court as set out in the Civil Procedure Rules (CPR
                      Part 35), Family Procedure Rules (FPR Part 25), or
                      Criminal Procedure Rules (CrPR Part 19) as applicable. All
                      assessments and reports will be conducted with
                      impartiality, objectivity, and independence, regardless of
                      the instructing party.
                    </p>
                  </div>}
              </div>
              {/* Services Provided Section */}
              <div className="border border-gray-200 rounded-lg overflow-hidden" data-id="element-902" data-mp="3b2ob7kafqw84">
                <button className={`w-full px-6 py-4 text-left flex justify-between items-center ${openSections.services ? 'bg-primary text-white' : 'bg-gray-50 text-primary'}`} onClick={() => toggleSection('services')} data-id="element-903" data-mp="3678vsnws4s9l">
                  <div className="flex items-center" data-id="element-904" data-mp="3tu8qxlpgza44">
                    <Users className="h-5 w-5 mr-2" data-id="element-905" data-mp="3ow77v0s1nasn" />
                    <h2 className="text-xl font-serif font-bold" data-id="element-906" data-mp="3ovdxlptvm35r">
                      4. Services Provided
                    </h2>
                  </div>
                  {openSections.services ? <ChevronUp className="h-5 w-5" data-id="element-907" data-mp="2pie6xg6kw27" /> : <ChevronDown className="h-5 w-5" data-id="element-908" data-mp="29enbehmpgs2z" />}
                </button>
                {openSections.services && <div className="p-6 bg-white" data-id="element-909" data-mp="24iezre7pvh0k">
                    <p className="text-slate-dark mb-4" data-id="element-910" data-mp="jy1gu9v9ojgy">
                      Services may include, but are not limited to:
                    </p>
                    <ul className="list-disc pl-6 mb-4 text-slate-dark" data-id="element-911" data-mp="ozgzjv9z2dw6">
                      <li data-id="element-912" data-mp="a7ypee3sndkq">
                        Review of documentation provided by the Instructing
                        Party
                      </li>
                      <li data-id="element-913" data-mp="17aaziahnb7b">
                        Psychiatric assessment of the Subject (remote or
                        in-person)
                      </li>
                      <li data-id="element-914" data-mp="57apf2xl7med">Preparation of medico-legal reports</li>
                      <li data-id="element-915" data-mp="3ngbj3oswhi62">Attendance at conferences with counsel</li>
                      <li data-id="element-916" data-mp="3sdl4mtd659om">
                        Expert witness testimony in court or tribunal
                        proceedings
                      </li>
                    </ul>
                    <p className="text-slate-dark" data-id="element-917" data-mp="1qmq4jpbxioc3">
                      The specific services to be provided will be detailed in
                      the Service Agreement.
                    </p>
                  </div>}
              </div>
              {/* Fees and Payment Section */}
              <div className="border border-gray-200 rounded-lg overflow-hidden" data-id="element-918" data-mp="2i192qxuukidk">
                <button className={`w-full px-6 py-4 text-left flex justify-between items-center ${openSections.fees ? 'bg-primary text-white' : 'bg-gray-50 text-primary'}`} onClick={() => toggleSection('fees')} data-id="element-919" data-mp="2hz645pfmpgx8">
                  <div className="flex items-center" data-id="element-920" data-mp="3eqq799i3fydo">
                    <DollarSign className="h-5 w-5 mr-2" data-id="element-921" data-mp="30s09drng9uo9" />
                    <h2 className="text-xl font-serif font-bold" data-id="element-922" data-mp="30tl4bidoffmn">
                      5. Fees and Payment
                    </h2>
                  </div>
                  {openSections.fees ? <ChevronUp className="h-5 w-5" data-id="element-923" data-mp="1peem6c15i35d" /> : <ChevronDown className="h-5 w-5" data-id="element-924" data-mp="1uc7tx9i3r57r" />}
                </button>
                {openSections.fees && <div className="p-6 bg-white" data-id="element-925" data-mp="1hsswsb6g645w">
                    <p className="text-slate-dark mb-4" data-id="element-926" data-mp="1hs0zmvx7bydi">
                      Fees are calculated based on the complexity of the case,
                      volume of documentation, type of assessment required, and
                      estimated time involved. The fee structure will be
                      outlined in the Service Agreement and may include:
                    </p>
                    <ul className="list-disc pl-6 mb-4 text-slate-dark" data-id="element-927" data-mp="z3482zt6vjyz">
                      <li data-id="element-928" data-mp="1ctfzsxlv3gpl">
                        Hourly rates for document review, report writing, and
                        conferences
                      </li>
                      <li data-id="element-929" data-mp="180wknw7j0dio">Fixed fees for assessments</li>
                      <li data-id="element-930" data-mp="kcdd5iwaw4rn">Daily rates for court attendance</li>
                      <li data-id="element-931" data-mp="febtavr1w1f4">Travel expenses and time (where applicable)</li>
                      <li data-id="element-932" data-mp="fe261fxe48d4">
                        Cancellation fees (as per our Cancellation Policy)
                      </li>
                    </ul>
                    <p className="text-slate-dark" data-id="element-933" data-mp="2kewgn43howl1">
                      Payment terms are 30 days from the date of invoice. For
                      Legal Aid cases, Dr. Syed will work within the approved
                      funding limits, provided these are agreed upon in advance.
                    </p>
                  </div>}
              </div>
              {/* Timelines and Delivery */}
              <div className="border border-gray-200 rounded-lg overflow-hidden" data-id="element-934" data-mp="21hlhdjhuy35l">
                <button className={`w-full px-6 py-4 text-left flex justify-between items-center ${openSections.timelines ? 'bg-primary text-white' : 'bg-gray-50 text-primary'}`} onClick={() => toggleSection('timelines')} data-id="element-935" data-mp="26fn9sv16betq">
                  <div className="flex items-center" data-id="element-936" data-mp="3lwdntfy6xjlf">
                    <Clock className="h-5 w-5 mr-2" data-id="element-937" data-mp="3lv2njq3yetz2" />
                    <h2 className="text-xl font-serif font-bold" data-id="element-938" data-mp="1a9tn3kvdpd7n">
                      6. Timelines and Delivery
                    </h2>
                  </div>
                  {openSections.timelines ? <ChevronUp className="h-5 w-5" data-id="element-939" data-mp="11g6uu4qdqs37" /> : <ChevronDown className="h-5 w-5" data-id="element-940" data-mp="wi5cjm0s2wss" />}
                </button>
                {openSections.timelines && <div className="p-6 bg-white" data-id="element-941" data-mp="rjltpuhhe14n">
                    <p className="text-slate-dark mb-4" data-id="element-942" data-mp="mjzczb2g22r3">
                      Dr. Syed aims to deliver reports within 10 working days of
                      the assessment, subject to the complexity of the case and
                      volume of documentation. Expedited reports (within 5
                      working days) may be available by prior arrangement and
                      may incur additional fees.
                    </p>
                    <p className="text-slate-dark" data-id="element-943" data-mp="27ydi7wbiao8o">
                      While every effort will be made to meet agreed deadlines,
                      Dr. Syed cannot be held liable for delays resulting from
                      factors outside his control, such as the late provision of
                      documentation or the Subject's non-attendance.
                    </p>
                  </div>}
              </div>
              {/* Confidentiality and Data Protection */}
              <div className="border border-gray-200 rounded-lg overflow-hidden" data-id="element-944" data-mp="luvkoyki1fi3">
                <button className={`w-full px-6 py-4 text-left flex justify-between items-center ${openSections.dataProtection ? 'bg-primary text-white' : 'bg-gray-50 text-primary'}`} onClick={() => toggleSection('dataProtection')} data-id="element-945" data-mp="qnf6gitcbgxz">
                  <div className="flex items-center" data-id="element-946" data-mp="2wj790mk1jgp">
                    <Lock className="h-5 w-5 mr-2" data-id="element-947" data-mp="2yvwlyun6w3s" />
                    <h2 className="text-xl font-serif font-bold" data-id="element-948" data-mp="7uuh3bcuntyx">
                      7. Confidentiality and Data Protection
                    </h2>
                  </div>
                  {openSections.dataProtection ? <ChevronUp className="h-5 w-5" data-id="element-949" data-mp="3fhyg8cfr2vap" /> : <ChevronDown className="h-5 w-5" data-id="element-950" data-mp="3uepc4bq7tovk" />}
                </button>
                {openSections.dataProtection && <div className="p-6 bg-white" data-id="element-951" data-mp="3pgxkzjxea6sf">
                    <p className="text-slate-dark mb-4" data-id="element-952" data-mp="77wv7957cv60">
                      Dr. Syed will handle all information in accordance with
                      the UK General Data Protection Regulation (UK GDPR), the
                      Data Protection Act 2018, and relevant professional
                      guidelines. Please refer to our Privacy Policy for
                      detailed information on how we collect, use, and protect
                      personal data.
                    </p>
                    <p className="text-slate-dark" data-id="element-953" data-mp="lz5p3ug512oy">
                      The Instructing Party is responsible for obtaining
                      appropriate consent from the Subject for the sharing of
                      their personal data with Dr. Syed for the purpose of
                      assessment and report preparation.
                    </p>
                  </div>}
              </div>
              {/* Intellectual Property */}
              <div className="border border-gray-200 rounded-lg overflow-hidden" data-id="element-954" data-mp="1brskw742z5v5">
                <button className={`w-full px-6 py-4 text-left flex justify-between items-center ${openSections.intellectual ? 'bg-primary text-white' : 'bg-gray-50 text-primary'}`} onClick={() => toggleSection('intellectual')} data-id="element-955" data-mp="1btwr4vpgcgyl">
                  <div className="flex items-center" data-id="element-956" data-mp="1qmqf75isi5ev">
                    <FileText className="h-5 w-5 mr-2" data-id="element-957" data-mp="3nhuu1m50uzoz" />
                    <h2 className="text-xl font-serif font-bold" data-id="element-958" data-mp="3njfsvnydd4sn">
                      8. Intellectual Property
                    </h2>
                  </div>
                  {openSections.intellectual ? <ChevronUp className="h-5 w-5" data-id="element-959" data-mp="24ucv2ossghgp" /> : <ChevronDown className="h-5 w-5" data-id="element-960" data-mp="24s8kxp4aqm7z" />}
                </button>
                {openSections.intellectual && <div className="p-6 bg-white" data-id="element-961" data-mp="1vug5mkykrekl">
                    <p className="text-slate-dark" data-id="element-962" data-mp="1vrk7owmq8pw5">
                      All reports and documents prepared by Dr. Syed remain his
                      intellectual property. The Instructing Party is granted a
                      license to use these documents for the specific legal
                      proceedings for which they were commissioned. Any other
                      use requires Dr. Syed's written permission.
                    </p>
                  </div>}
              </div>
              {/* Cancellation and Rescheduling */}
              <div className="border border-gray-200 rounded-lg overflow-hidden" data-id="element-963" data-mp="1347v9faa5ygk">
                <button className={`w-full px-6 py-4 text-left flex justify-between items-center ${openSections.cancellation ? 'bg-primary text-white' : 'bg-gray-50 text-primary'}`} onClick={() => toggleSection('cancellation')} data-id="element-964" data-mp="336z6kdyqj5ea">
                  <div className="flex items-center" data-id="element-965" data-mp="2y7mar3pvynzk">
                    <Clock className="h-5 w-5 mr-2" data-id="element-966" data-mp="2y8e5ydfkmjpb" />
                    <h2 className="text-xl font-serif font-bold" data-id="element-967" data-mp="3lxgp5ppusklx">
                      9. Cancellation and Rescheduling
                    </h2>
                  </div>
                  {openSections.cancellation ? <ChevronUp className="h-5 w-5" data-id="element-968" data-mp="3c75ku229c9ei" /> : <ChevronDown className="h-5 w-5" data-id="element-969" data-mp="3h68eyrgp8v7p" />}
                </button>
                {openSections.cancellation && <div className="p-6 bg-white" data-id="element-970" data-mp="8p3sq79d41ww">
                    <p className="text-slate-dark" data-id="element-971" data-mp="di6peo9frrhb">
                      Please refer to our separate Cancellation Policy for
                      detailed terms regarding the cancellation or rescheduling
                      of appointments and court attendance.
                    </p>
                  </div>}
              </div>
              {/* Liability */}
              <div className="border border-gray-200 rounded-lg overflow-hidden" data-id="element-972" data-mp="22zapkj9ffqnx">
                <button className={`w-full px-6 py-4 text-left flex justify-between items-center ${openSections.liability ? 'bg-primary text-white' : 'bg-gray-50 text-primary'}`} onClick={() => toggleSection('liability')} data-id="element-973" data-mp="1f9gbjyddfw23">
                  <div className="flex items-center" data-id="element-974" data-mp="1obh4ij1knvxy">
                    <AlertCircle className="h-5 w-5 mr-2" data-id="element-975" data-mp="1k8b2xopemsxt" />
                    <h2 className="text-xl font-serif font-bold" data-id="element-976" data-mp="1kax9bl0k72eg">
                      10. Liability
                    </h2>
                  </div>
                  {openSections.liability ? <ChevronUp className="h-5 w-5" data-id="element-977" data-mp="2vq2dyuk93b0p" /> : <ChevronDown className="h-5 w-5" data-id="element-978" data-mp="2kh4bc6z3a5zu" />}
                </button>
                {openSections.liability && <div className="p-6 bg-white" data-id="element-979" data-mp="2ueqp2q4njri8">
                    <p className="text-slate-dark" data-id="element-980" data-mp="2uglb67rntpnw">
                      Dr. Syed maintains appropriate professional indemnity
                      insurance. His liability is limited to the fees paid for
                      the specific services provided. Dr. Syed is not liable for
                      any consequential, indirect, or special losses arising
                      from the provision of his services.
                    </p>
                  </div>}
              </div>
              {/* Complaints */}
              <div className="border border-gray-200 rounded-lg overflow-hidden" data-id="element-981" data-mp="3n3pem8b3tvxk">
                <button className={`w-full px-6 py-4 text-left flex justify-between items-center ${openSections.complaints ? 'bg-primary text-white' : 'bg-gray-50 text-primary'}`} onClick={() => toggleSection('complaints')} data-id="element-982" data-mp="3n1bidw4oudof">
                  <div className="flex items-center" data-id="element-983" data-mp="9lsuioi913iv">
                    <HelpCircle className="h-5 w-5 mr-2" data-id="element-984" data-mp="3rsqhfeo6wrj5" />
                    <h2 className="text-xl font-serif font-bold" data-id="element-985" data-mp="3rubcd5ef2chj">
                      11. Complaints
                    </h2>
                  </div>
                  {openSections.complaints ? <ChevronUp className="h-5 w-5" data-id="element-986" data-mp="3i0knhzedo01b" /> : <ChevronDown className="h-5 w-5" data-id="element-987" data-mp="3muoyquuoeu87" />}
                </button>
                {openSections.complaints && <div className="p-6 bg-white" data-id="element-988" data-mp="3e0k92era3ou9">
                    <p className="text-slate-dark" data-id="element-989" data-mp="3e1bs6q3ovu3n">
                      If the Instructing Party is dissatisfied with any aspect
                      of Dr. Syed's services, they should first raise their
                      concerns directly with Dr. Syed. If the matter cannot be
                      resolved, the Instructing Party may refer to the relevant
                      professional body (e.g., General Medical Council, Royal
                      College of Psychiatrists) as appropriate.
                    </p>
                  </div>}
              </div>
              {/* Governing Law */}
              <div className="border border-gray-200 rounded-lg overflow-hidden" data-id="element-990" data-mp="267aa1rw6szmd">
                <button className={`w-full px-6 py-4 text-left flex justify-between items-center ${openSections.governing ? 'bg-primary text-white' : 'bg-gray-50 text-primary'}`} onClick={() => toggleSection('governing')} data-id="element-991" data-mp="33w3sfj5z63pe">
                  <div className="flex items-center" data-id="element-992" data-mp="2oytb3t6ni3lr">
                    <Scale className="h-5 w-5 mr-2" data-id="element-993" data-mp="1ijak2u6p9d8u" />
                    <h2 className="text-xl font-serif font-bold" data-id="element-994" data-mp="1il3qq9hbbxgu">
                      12. Governing Law
                    </h2>
                  </div>
                  {openSections.governing ? <ChevronUp className="h-5 w-5" data-id="element-995" data-mp="3p9m95luiw8k7" /> : <ChevronDown className="h-5 w-5" data-id="element-996" data-mp="3u7xfvnpiu2y7" />}
                </button>
                {openSections.governing && <div className="p-6 bg-white" data-id="element-997" data-mp="2yrq3nugsv7n">
                    <p className="text-slate-dark" data-id="element-998" data-mp="7scr7orcu5b2">
                      These Terms and Conditions are governed by the laws of
                      England and Wales. Any disputes arising from these terms
                      shall be subject to the exclusive jurisdiction of the
                      courts of England and Wales.
                    </p>
                  </div>}
              </div>
              {/* Amendments */}
              <div className="border border-gray-200 rounded-lg overflow-hidden" data-id="element-999" data-mp="qnt4rstw52ld">
                <button className={`w-full px-6 py-4 text-left flex justify-between items-center ${openSections.amendments ? 'bg-primary text-white' : 'bg-gray-50 text-primary'}`} onClick={() => toggleSection('amendments')} data-id="element-1000" data-mp="2nkjvk6ye73tn">
                  <div className="flex items-center" data-id="element-1001" data-mp="htn8p4dlps05">
                    <FileText className="h-5 w-5 mr-2" data-id="element-1002" data-mp="vto8egi4qte1" />
                    <h2 className="text-xl font-serif font-bold" data-id="element-1003" data-mp="vt50ztq3vne9">
                      13. Amendments
                    </h2>
                  </div>
                  {openSections.amendments ? <ChevronUp className="h-5 w-5" data-id="element-1004" data-mp="4308f7s6zu1y" /> : <ChevronDown className="h-5 w-5" data-id="element-1005" data-mp="3vacqdp0wgbix" />}
                </button>
                {openSections.amendments && <div className="p-6 bg-white" data-id="element-1006" data-mp="84dgloirc9c1">
                    <p className="text-slate-dark" data-id="element-1007" data-mp="83k6cdklb1p5">
                      Dr. Syed reserves the right to amend these Terms and
                      Conditions from time to time. The latest version will
                      always be available on our website. The version in effect
                      at the time of instruction will apply to that specific
                      case.
                    </p>
                  </div>}
              </div>
            </div>
          </div>
        </div>
      </section>
    </main>;
}